import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FinancialDocumentPurchaseOrderFragment,
  GetPurchaseOrdersSelectorDocument,
  GetPurchaseOrdersSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import i18n from 'modules/core/lib/i18n'

import {
  FinancePurchaseOrderSelectorMultipleProps,
  FinancePurchaseOrderSelectorSingleProps,
} from './types'

const FinancePurchaseOrderItem = ({
  purchaseOrder,
}: {
  purchaseOrder: FinancialDocumentPurchaseOrderFragment
}) => {
  return (
    <Box gap="s2">
      <Box flexDirection="row" alignItems="center" gap="s8">
        <Text.Normal weight="medium" color="grey1000">
          {purchaseOrder.formattedPoNumber}
        </Text.Normal>
      </Box>
      {purchaseOrder.description && (
        <Box flexDirection="row">
          <Text.Normal size="200">{purchaseOrder.description}</Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export const FinancePurchaseOrderSelector: React.FC<
  FinancePurchaseOrderSelectorSingleProps | FinancePurchaseOrderSelectorMultipleProps
> = (props) => {
  const { value, multiple, companyId } = props

  const variables = {
    companyId,
  }

  const extractConnection = (data: GetPurchaseOrdersSelectorQuery) => {
    return data.procurement.purchaseOrdersConnection
  }

  const renderEntity = (entity: FinancialDocumentPurchaseOrderFragment) => {
    return <FinancePurchaseOrderItem purchaseOrder={entity} />
  }

  const commonProps = {
    document: GetPurchaseOrdersSelectorDocument,
    extractConnection,
    label: i18n.t('finance.invoices.detail.associated_resource_purchase_order_type'),
    renderEntity,
    disabled: props.disabled,
    variables,
  }

  if (multiple) {
    const selectorProps = { ...commonProps, ...props }

    return (
      <EntitySelector.Multiple
        {...selectorProps}
        renderValue={(purchaseOrders) => (
          <Text.Normal ellipsis>
            {purchaseOrders.length > 0
              ? purchaseOrders.map((po) => po.formattedPoNumber).join(', ')
              : i18n.t('common.select_multiple')}
          </Text.Normal>
        )}
      />
    )
  }

  const selectorProps = { ...commonProps, ...props }

  return (
    <EntitySelector
      {...selectorProps}
      renderValue={(entity) =>
        entity !== null && entity != undefined ? (
          <Text.Normal ellipsis>{entity.formattedPoNumber}</Text.Normal>
        ) : (
          <Text.Normal>{i18n.t('common.select')}</Text.Normal>
        )
      }
    />
  )
}
